module.exports = __webpack_public_path__ + "static/media/hm.dc6db186.svg";